export interface CountryPlaceIdMapping {
  [isoCode: string]: string;
}

const countryPlaceIdMapping: CountryPlaceIdMapping = {
  AF: "ChIJbQL_-LZu0TgReNqWvg1GtfM",
  AL: "ChIJLUwnvfM7RRMR7juY1onlfAc",
  DZ: "ChIJ0XsDKGqKfg0RovjXq-O-QHE",
  AD: "ChIJlfCemC71pRIRkn_qeNc-yQc",
  AO: "ChIJJ4utyk7yURoRPU5KDZ0oClk",
  AG: "ChIJwdG4bbluDYwRlHmL4Yg3aic",
  AR: "ChIJZ8b99fXKvJURqA_wKpl3Lz0",
  AM: "ChIJx7pz54RWFUARIy2C63p1tNA",
  AU: "ChIJ38WHZwf9KysRUhNblaFnglM",
  AT: "ChIJfyqdJZsHbUcRr8Hk3XvUEhA",
  AZ: "ChIJ3x2iGtl8MEARCM2DPmtSyeY",
  BS: "ChIJPQ9Isjua1ogR5XnHaoO0PhM",
  BH: "ChIJEaJHak5SSD4RRhDa2-JQlC4",
  BD: "ChIJp4vhgO2qrTARa_zhxOAoLQ8",
  BB: "ChIJoxoyrvvxQ4wRKzb0jLNR7A4",
  BY: "ChIJgUit4oQl2kYREIzsgdGhAAA",
  BE: "ChIJl5fz7WR9wUcR8g_mObTy60c",
  BZ: "ChIJ-foSwT5bXI8RTuMeP02KSvY",
  BJ: "ChIJlVZ6BCtUIxAR9S5iy_h3suw",
  BT: "ChIJz5XFc6WSWzcR2rw2KGWsDLs",
  BO: "ChIJlaK7d4nfXpERv-0VAbvCnhw",
  BA: "ChIJ16k3xxWiSxMRDOm3QwPi920",
  BW: "ChIJESJF0SFDpB4Re68Vhyp8ZPE",
  BR: "ChIJzyjM68dZnAARYz4p8gYVWik",
  BN: "ChIJ0bm4BEuZGDIR1toJ3YA1_l0",
  BG: "ChIJifBbyMH-qEAREEy_aRKgAAA",
  BF: "ChIJm3Cm1SbKLQ4Rq22DRu0Kkyc",
  BI: "ChIJW_FUNtNEwRkRjewxVg5NI7E",
  CV: "ChIJMVERWSGPNQkRH-oY-TbyGms",
  KH: "ChIJQzfc1L-HBzERUxL0ieC_t-Q",
  CM: "ChIJIQ8-cFM3YRARU5uCmUXEAys",
  CA: "ChIJ2WrMN9MDDUsRpY9Doiq3aJk",
  CF: "ChIJt6KGjVPpuBARJIBcWgLGm7g",
  TD: "ChIJYXNnvXg55xARnIDAzluDYDs",
  CL: "ChIJL68lBEHFYpYRHbkCERPhBQU",
  CN: "ChIJwULG5WSOUDERbzafNHyqHZU",
  CO: "ChIJo5QVrjqkFY4RQKPy7wSaDZo",
  KM: "ChIJjaQIZAPjmBgR29Tf5L5_Cvc",
  CG: "ChIJvUZ1ms_6eRkRQfGTrF4-xgQ",
  CD: "ChIJCROj3WOlYBoRj2z8FM96AVU",
  CR: "ChIJJcmsIWLlko8RK5qBNSX3VGI",
  HR: "ChIJ7ZXdCghBNBMRfxtm4STA86A",
  CU: "ChIJtUx6DwdJzYgRGqQQkVL3jHk",
  CY: "ChIJVU1JymcX3hQRbhTEf4A8TDI",
  CZ: "ChIJQ4Ld14-UC0cRb1jb03UcZvg",
  DK: "ChIJ-1-U7rYnS0YRzZLgw9BDh1I",
  DJ: "ChIJAfb5NGfUIhYRiFsP76e7chQ",
  DM: "ChIJFVoV8vrSFIwRPP06BQmRs0k",
  DO: "ChIJ9bbx3jiIr44R4PcNBiQPAqY",
  EC: "ChIJ1UuaqN2HI5ARAjecEQSvdp0",
  EG: "ChIJ6TZcw3aJNhQRRMTEJQmgRSw",
  SV: "ChIJVwZkWaYnY48RMkiFmOsWmm8",
  GQ: "ChIJp4euX2A6ZBARet4QLKKicMg",
  ER: "ChIJZYW6nT9abRYR-g4SL_AIwhc",
  EE: "ChIJ_UuggpyUkkYRwyW0T7qf6kA",
  SZ: "ChIJBw8yR-HO6B4RaXANGC_GPcE",
  ET: "ChIJK_1s3c7QNRYRWsVIU3-m9ns",
  FJ: "ChIJXdw8cP2QGW4Rk1vvRpkxnJ4",
  FI: "ChIJ3fYyS9_KgUYREKh1PNZGAQA",
  FR: "ChIJMVd4MymgVA0R99lHx5Y__Ws",
  GA: "ChIJ7fM4VIo7fxARFWt4Ng7DDHs",
  GM: "ChIJBzivZSmcwg4RKp0Ta0BMSp4",
  GE: "ChIJa2JP5tcMREARwkotEmR5kE8",
  DE: "ChIJa76xwh5ymkcRW-WRjmtd6HU",
  GH: "ChIJx9baqM1a1w8RNtKT0DDy11Q",
  GR: "ChIJY2xxEcdKWxMRHS2a3HUXOjY",
  GD: "ChIJ0XuH9IkXOIwRjk8fWgHH2DY",
  GT: "ChIJa1DnNlATiIURu9WEWzcrmDU",
  GN: "ChIJP5XOvCGzAQ8R9i1a18t7c-g",
  GW: "ChIJ8amCr3Q85A4RTggeVz-O6Ls",
  GY: "ChIJs8LYYK_vr40RQETltmeI40g",
  HT: "ChIJEbvLf_PGto4R0_ZUTLI4FLU",
  HN: "ChIJzzG3cxp1ao8RZIL7toLe0X4",
  HU: "ChIJw-Q333uDQUcREBAeDCnEAAA",
  IS: "ChIJQ2Dro1Ir0kgRmkXB5TQEim8",
  IN: "ChIJkbeSa_BfYzARphNChaFPjNc",
  ID: "ChIJtwRkSdcHTCwRhfStG-dNe-M",
  IR: "ChIJ8R1rwS7s9z4RzvpRntOVsEA",
  IQ: "ChIJEUr1VD2CVxURAhYGorthpW0",
  IE: "ChIJ-ydAXOS6WUgRCPTbzjQSfM8",
  IL: "ChIJi8mnMiRJABURuiw1EyBCa2o",
  IT: "ChIJA9KNRIL-1BIRb15jJFz1LOI",
  JM: "ChIJnXHPxhsq2o4R-g4StcDRoFk",
  JP: "ChIJLxl_1w9OZzQRRFJmfNR1QvU",
  JD: "ChIJmd5kZkdvABURmU4mUQdbKI0",
  KZ: "ChIJR6n87AcQqTgRGw6z5C-Ee18",
  KE: "ChIJD5BQg9CAJxgR2W2XobAOO0A",
  KI: "ChIJA4cCwpF8ZGURB8NSAQR9MoQ",
  KR: "ChIJm7oRy-tVZDURS9uIugCbJJE",
  KW: "ChIJoVHqvj82xT8R0u3Yks1rcnQ",
  KG: "ChIJ8yfp_B04lzgRM8SITrdYECg",
  LA: "ChIJiUWCsFeQFDERgc2ZH0iSxQ4",
  LV: "ChIJ_ZqKe2cw6UYREPzyaM3PAAA",
  LB: "ChIJraoihAIXHxURcPkAbAk0fcw",
  LS: "ChIJ64xf1idIjB4Rsx7ReLhXLSM",
  LR: "ChIJwfyp1AP4CQ8Rc2PRMmso038",
  LY: "ChIJDQHOjtmSqBMRKsL5x0FgB_o",
  LI: "ChIJ_S9HHUQxm0cRibFa3Ta16mA",
  LT: "ChIJE74zDxSU3UYRubpdpdNUCvM",
  LU: "ChIJRyEhyrlFlUcR75LTAvZg22Q",
  MG: "ChIJRYUj6uOk0SERiBN7l8HjRFI",
  MW: "ChIJ18ATk91b2BgRQ4VmKRcuo0Q",
  MY: "ChIJrzBnX5fTNDAR2BwhKJOWRQc",
  MV: "ChIJvXv7qr-ZtSQRiWKVgeEJRUE",
  ML: "ChIJz3MQG4g-FA4RgM-9oOJbOrs",
  MT: "ChIJxUeGHShFDhMROUK-NmHYgvU",
  MH: "ChIJK8opIbIZAWURdrcJqugDPos",
  MR: "ChIJTzmzFMO4gA4RTlO-1usLIoM",
  MU: "ChIJyXRE-U1QfCERMdBrEcLZA0I",
  MX: "ChIJU1NoiDs6BIQREZgJa760ZO0",
  FM: "ChIJE8hYrMW12WURJWWk-s2NelQ",
  MD: "ChIJoWm3KDZ8yUARy6xT36wZgSU",
  MC: "ChIJMYU_e2_CzRIR_JzEOkx493Q",
  MN: "ChIJS22qaQYFJzYRluDmNzkh3eA",
  ME: "ChIJyx8sJBcyTBMRRtP_boadTDg",
  MA: "ChIJjcVRlmGICw0Rw_8sxIGT09k",
  MZ: "ChIJxUr95uqs1BgRFaEWrrm_uxI",
  MM: "ChIJBylOcadSVjAREStiHOQOe7o",
  NA: "ChIJIXXTbn489RsRYbLsqKXludM",
  NR: "ChIJTVvkHR8cfW8RgQrUxfSd2Vk",
  NP: "ChIJz2gufcfolTkR3obM0LyaojQ",
  NL: "ChIJu-SH28MJxkcRnwq9_851obM",
  NZ: "ChIJh5Z3Fw4gLG0RM0dqdeIY1rE",
  NI: "ChIJzSL_zgDCEI8RtRWsP-Wn-sg",
  NE: "ChIJXa-hxnrsmRER1CSOFQqSM8k",
  NG: "ChIJDY2kfa8LThARyAvFaEH-qJk",
  NO: "ChIJv-VNj0VoEkYRK9BkuJ07sKE",
  OM: "ChIJv5vVqWaf1j0RF6ixZXZMBjo",
  PK: "ChIJH3X9-NJS2zgRXJIU5veht0Y",
  PW: "ChIJmQOvorRFhDIRu-uhOd0e7RI",
  PA: "ChIJ4yu-yIMVpo8Rz5ulH03g7nk",
  PG: "ChIJr54Ov6_oWWgRehKcjg3l8No",
  PY: "ChIJYz3xkDQIXJQR8y5YHWH_-rM",
  PE: "ChIJ9RRZwFDIBZERSAYheRIBnvI",
  PH: "ChIJY96HXyFTQDIRV9opeu-QR3g",
  PL: "ChIJuwtkpGSZAEcR6lXMScpzdQk",
  PT: "ChIJ1SZCvy0kMgsRQfBOHAlLuCo",
  QR: "ChIJf-jc_zTFRT4RMkArgc-I-hw",
  // QR: "ChIJEVKhX6fFzD8Rg0AbdTDZs0A",
  RO: "ChIJw3aJlSb_sUARlLEEqJJP74Q",
  RU: "ChIJ-yRniZpWPEURE_YRZvj9CRQ",
  RW: "ChIJ40A451SWwhkRA6HMyyawkHQ",
  KN: "ChIJDXKKxm4ZEowR6IYdmsaa6d4",
  LC: "ChIJHaMt8WVgQIwR9Z056MSGdG4",
  VC: "ChIJuzU5nuKsQIwRsaHSjejT_TE",
  WS: "ChIJAxDsZKMTpXERcnhhdJYMh6Y",
  SM: "ChIJeT_m9V_rLBMRECA0gpnzAAA",
  ST: "ChIJidiaC_nscBAR6jB2VQwjUWI",
  SA: "ChIJQSqV5z-z5xURm7YawktQYFk",
  SN: "ChIJcbvFs_VywQ4RQFlhmVClRlo",
  RS: "ChIJlYCJ8t8dV0cRXYYjN-pQXgU",
  SC: "ChIJO62-cP0hXCIR99pJ06DQ0zI",
  SL: "ChIJQ_OrOhgGAQ8RGfcsx83paVM",
  SG: "ChIJdZOLiiMR2jERxPWrUs9peIg",
  SK: "ChIJf8Z8rrlgFEcRfTpysWdha80",
  SI: "ChIJYYOWXuckZUcRZdTiJR5FQOc",
  SB: "ChIJ0QlQVeBR02gRgClEF6DATLQ",
  SO: "ChIJg1vR7KcuHRgRvuXpXM46OZ4",
  ZA: "ChIJURLu2YmmNBwRoOikHwxjXeg",
  SS: "ChIJGTE-PbUwGRcRl7y2fmND8Ns",
  ES: "ChIJi7xhMnjjQgwR7KNoB5Qs7KY",
  LK: "ChIJnR5a9jxZ4joRjNPiALSkPeE",
  SD: "ChIJlbFyEMQc2RURNythKkZwv9I",
  SR: "ChIJUdXT2dU2CI0RsjYpccDhNxA",
  SE: "ChIJ8fA1bTmyXEYRYm-tjaLruCI",
  CH: "ChIJYW1Zb-9kjEcRFXvLDxG1Vlw",
  SY: "ChIJp8Y8QdzmGBURIPYqiPRGdYc",
  TJ: "ChIJzbO8enN2sTgRtYgZT4QxwyU",
  TZ: "ChIJEaFpSDFRSxgRMMTBSzEXWog",
  TH: "ChIJsU1CR_eNTTARAuhXB4gs154",
  TL: "ChIJKaHkhgnl_SwRPFvoh4PG5QM",
  TG: "ChIJGVQYE8HhIxARYJPRGjBbrvo",
  TO: "ChIJHdCfu0S2k3ERqeJexcrMbfM",
  TT: "ChIJxbZQY5cHNowRJ_E5xlUoCP8",
  TN: "ChIJ4aQWg0SVVRIR75sBqjozhDo",
  TR: "ChIJcSZPllwVsBQRKl9iKtTb2UA",
  TM: "ChIJy2y8dFXLZT8RkaRpQWuC3X4",
  TV: "ChIJTaCxWbmcwW8RLhIHB2hUZ48",
  UG: "ChIJRfmZZJ-mcRcRSUUBQ85VQYc",
  UA: "ChIJjw5wVMHZ0UAREED2iIQGAQA",
  AE: "ChIJvRKrsd9IXj4RpwoIwFYv0zM",
  GB: "ChIJqZHHQhE7WgIReiWIMkOg-MQ",
  US: "ChIJCzYy5IS16lQRQrfeQ5K5Oxw",
  UY: "ChIJCd5f-zoHdZURSlIWYGGWVUo",
  UZ: "ChIJsXbWpSCLrjgRIB6Efq1tCso",
  VU: "ChIJE2CSyF5giW4RaibQvs85gzQ",
  VA: "ChIJPS3UVwqJJRMRsH46sppPCQA",
  VE: "ChIJAdjLNstTKIwR003VfFjyoNw",
  VN: "ChIJXx5qc016FTERvmL-4smwO7A",
  YE: "ChIJX7w0fKzbAxYRrneufjcp8ZI",
  ZM: "ChIJcQv8_KX0QBkRRT5Yfqz5n_E",
  ZW: "ChIJYXGxBuekMRkR7r_LxV84wKE",
};

export default countryPlaceIdMapping;
